/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{frame as o,cancelFrame as r}from"../frameloop/index.js";function e(e,n){const t=performance.now(),m=({timestamp:o})=>{const p=o-t;p>=n&&(r(m),e(p-n))};return o.read(m,!0),()=>r(m)}export{e as delay};
//# sourceMappingURL=delay.js.map
